const WA = 'https://wa.me/5555996946460?text=Olá,%20vim%20pelo%20Google%20e%20quero%20agendar%20consulta';
const HERO_IMG = 'https://storage.readdy-site.link/project_files/d1b5596e-1952-4672-9c5f-425388885f69/8818de03-4013-43a9-827d-3f4b09b2aa94_Design-sem-nome-81.png?v=da3036de095929c8f71fab1589a36726';

export default function HeroSection() {
  const scrollToSobre = () => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="home" className="relative bg-[#F5F5F0] overflow-hidden">

      {/* MOBILE */}
      <div className="lg:hidden relative w-full h-screen flex flex-col justify-end">
        <img
          src={HERO_IMG}
          alt="Dra. Mariangela Escobar Gonçalves"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
        <div className="relative z-10 px-6 pb-14 text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#6B705C]"></div>
            <span className="text-sm font-medium text-white">Médica – CRM 63381</span>
          </div>
          <h2 className="text-base font-semibold text-[#4F5D4A] mb-1 tracking-wide">Mariangela Escobar Gonçalves</h2>
          <h1 className="text-3xl font-bold text-white mb-4 leading-tight">
            Cuidado completo para sua saúde em <span className="text-[#4F5D4A]">todas as fases</span> da vida.
          </h1>
          <p className="text-sm text-white/80 mb-8 max-w-sm mx-auto">
            Atendimento humanizado com foco em longevidade, prevenção e qualidade de vida.
          </p>
          <div className="flex flex-col gap-3 max-w-xs mx-auto">
            <a
              href={WA}
              onClick={(e) => {
                e.preventDefault();

                if (typeof gtag_report_conversion === 'function') {
                  gtag_report_conversion(WA);
                } else {
                  window.open(WA, '_blank');
                }
              }}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#4F5D4A] to-[#6B705C] text-white px-8 py-3.5 rounded-lg text-sm font-semibold hover:from-[#3D4A38] hover:to-[#4F5D4A] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg"
            >
              <i className="ri-whatsapp-line text-lg"></i>Agendar Consulta
            </a>
            <button
              onClick={scrollToSobre}
              className="bg-white/20 backdrop-blur-sm text-white border border-white/40 px-8 py-3.5 rounded-lg text-sm font-semibold hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Saiba mais
            </button>
          </div>
        </div>
      </div>

      {/* DESKTOP */}
      <div className="hidden lg:block">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-[#6B705C]/10 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-tr from-[#4F5D4A]/5 to-transparent rounded-full blur-3xl"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:py-28">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Text */}
            <div className="text-center lg:text-left relative z-10 mt-10">
              <div className="inline-flex items-center gap-2 bg-white/60 backdrop-blur-sm border border-[#6B705C]/30 rounded-full px-4 py-1.5 mb-6">
                <div className="w-2 h-2 rounded-full bg-[#4F5D4A]"></div>
                <span className="text-sm font-medium text-[#4F5D4A]">Médica – CRM 63381</span>
              </div>
              <h2 className="text-lg font-semibold text-[#4F5D4A] mb-2 tracking-wide">Mariangela Escobar Gonçalves</h2>
              <h1 className="text-4xl lg:text-5xl font-bold text-[#3A3A3A] mb-6 leading-tight">
                Cuidado completo para sua saúde em{' '}
                <span className="text-[#4F5D4A]">todas as fases</span> da vida.
              </h1>
              <p className="text-lg text-[#3A3A3A]/70 mb-10 max-w-lg">
                Atendimento humanizado com foco em longevidade, prevenção e qualidade de vida.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href={WA}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#4F5D4A] to-[#6B705C] text-white px-8 py-3.5 rounded-lg text-sm font-semibold hover:from-[#3D4A38] hover:to-[#4F5D4A] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-[#6B705C]/20"
                >
                  <i className="ri-whatsapp-line text-lg"></i>Agendar Consulta
                </a>
                <button
                  onClick={scrollToSobre}
                  className="bg-white text-[#6B705C] border-2 border-[#6B705C]/40 px-8 py-3.5 rounded-lg text-sm font-semibold hover:bg-[#F5F5F0] hover:border-[#6B705C] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Saiba mais
                </button>
              </div>
            </div>
            {/* Image */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                <div className="absolute -bottom-6 -left-6 w-72 h-72 bg-gradient-to-br from-[#6B705C]/20 to-[#4F5D4A]/10 rounded-full blur-2xl"></div>
                <div className="absolute -top-4 -right-4 w-48 h-48 bg-gradient-to-bl from-[#4F5D4A]/15 to-transparent rounded-full blur-2xl"></div>
                <div className="relative bg-gradient-to-b from-[#6B705C]/10 to-transparent p-1 rounded-2xl">
                  <img
                    src={HERO_IMG}
                    alt="Dra. Mariangela Escobar Gonçalves"
                    className="relative w-full max-w-md h-[550px] object-cover object-top rounded-2xl"
                  />
                </div>
                <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-sm rounded-xl px-6 py-3 shadow-lg border border-[#6B705C]/20">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-gradient-to-br from-[#4F5D4A] to-[#6B705C] rounded-full flex items-center justify-center">
                      <i className="ri-stethoscope-line text-white text-lg"></i>
                    </div>
                    <div>
                      <p className="text-xs text-[#3A3A3A]/60">Foco em</p>
                      <p className="text-sm font-semibold text-[#3A3A3A]">Longevidade &amp; Geriatria</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}